import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import React from "react";
interface ViewImageModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  link: string;
}

const ViewImageModal = ({
  isOpen,
  onRequestClose,
  link,
}: ViewImageModalProps) => {
  const [zoomedIn, setZoomedIn] = useState(false);
  const [cursorPosition, setCursorPosition] = useState<{
    x: number;
    y: number;
  }>({
    x: 0,
    y: 0,
  });

  const handleImageClick = (event: React.MouseEvent<HTMLImageElement>) => {
    // Calculate the position of the click relative to the image
    const rect = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    // Set the cursor position as the transform origin for zooming
    setCursorPosition({ x, y });

    // Toggle the zoom state
    setZoomedIn((prevState) => !prevState);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onRequestClose}>
      <DialogContent className="w-[95%] h-[95%] sm:max-w-[90%] sm:max-h-[90%]">
        <div className="flex justify-center items-center py-4 ">
          <img
            src={link}
            alt="Preview"
            onClick={handleImageClick}
            className={`max-w-full sm:max-h-[80vh] transition-transform duration-300 cursor-zoom-in ${
              zoomedIn ? "scale-150" : "scale-100"
            }`}
            style={{
              transformOrigin: `${cursorPosition.x}% ${cursorPosition.y}%`, // Apply transform origin based on cursor position
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewImageModal;
